import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { InvisibleAsset } from 'src/app/models/assets/InvisibleAsset';
import { Scene } from 'src/app/models/Scene';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-selection-details',
  templateUrl: './selection-details.component.html',
  styleUrls: ['./selection-details.component.scss'],
})
export class SelectionDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public ionSelectShapeOptions = {
    cssClass: 'quizard-select'
  };

  constructor(
    public validationService: ValidationService,
    public assetTypeService: AssetTypeService,
  ) { }

  ngOnInit() {}

  getSelectionAsset(): InvisibleAsset {
    let selectionAsset = this.assetInScene.baseAsset as InvisibleAsset;
    if (!selectionAsset.shape){
      selectionAsset.shape="square";
    }
    return selectionAsset;
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var sceneSettingsModal = document.getElementById('add-invisible-object-modal');
    sceneSettingsModal.style.opacity = opacity;
  }

  updateXScale(event, asset) {
    asset.sceneAssetRelation.xScale = String(event.detail.value);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  updateYScale(event, asset) {
    asset.sceneAssetRelation.yScale = String(event.detail.value);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  updateZRot(event, asset) {
    asset.sceneAssetRelation.zRot = String(event.detail.value);
    asset.sceneAssetRelation.rotation = `0 0 ${asset.sceneAssetRelation.zRot}`;
  }
}
